










































helpers = require('../../helpers.coffee')

view_model = {
  props: ['flow']

  components:
    reactivateRecipientModal: require('../automatic_tasks/reactivate_recipient_modal.vue')

  data: ->
    contacts: []
    filters: {}
    loading: false
    next_page: 1
    schedule_reactivation_contact: null
    selected_contact: {}

  methods:
    loadFlowContacts: ->
      return if @loading || !@next_page
      @loading = true
      @contact_resource.lastActiveOnFlow(
        @loadFlowContactsSuccess, @unknownError,
        flow_id: @flow.id, params: {q: @filters, page: @next_page}
      )

    loadFlowContactsSuccess: (resources) ->
      @loading = false
      @next_page = resources.meta.next_page
      @contacts = @contacts.concat(resources.contacts)
      @contacts = @contacts.sort (contact_1, contact_2) ->
        return 1 if contact_1.recipient_priority == null
        return -1 if contact_2.recipient_priority == null
        if contact_1.recipient_priority > contact_2.recipient_priority then 1 else -1

    filter: (filters) ->
      @filters = filters
      @next_page = 1
      @contacts = []
      @loadFlowContacts()

    openRemoveContactFromFlowModal: (data) ->
      @selected_contact = data.contact
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-remove-contact-from-flow'

    confirmRemoveContactFromFlow: ->
      @removeContactFromFlow(@selected_contact, @flow)

    openResetContactConfirmationModal: (data) ->
      @selected_contact = data.contact
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-reset-contact'

    callResetContact: ->
      @resetContactRecipient(@selected_contact)

    reloadContacts: ->
      @filter({})

  created: ->
    @contact_resource = new ContactsResource Session.current_company.id
    @loadFlowContacts()
    EventsBus.$on 'Contact::ScheduleRecipientReactivation', @openRecipientScheduleReactivationModal
    EventsBus.$on 'Contact::Refresh', @refreshContact
    EventsBus.$on 'Show::UpdateListContactsInfo', @updateContactList
    EventsBus.$on 'reload-contacts', @reloadContacts

  beforeDestroy: ->
    EventsBus.$off 'Contact::ScheduleRecipientReactivation', @openRecipientScheduleReactivationModal
    EventsBus.$off 'Contact::Refresh', @refreshContact
    EventsBus.$off 'Show::UpdateListContactsInfo', @updateContactList
    EventsBus.$off 'reload-contacts', @reloadContacts
}

exports.default = helpers.vue_include(view_model, helpers.contacts.list_view_modes, helpers.contacts.list_wrapper, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flows/contacts.vue